import React from 'react'
import { List, Flex, Button, Text } from '@leverege/ui-elements'

export default function RolePermissionList( props ) {
  
  const { roles = [], onEvent, headerOptions : HdrOpts, itemRenderer, itemProps } = props
  return (
    <List onEvent={onEvent}>
      <List.Dynamic 
        onEvent={onEvent} 
        items={roles} 
        component={itemRenderer || RoleItem} 
        itemProps={itemProps}/>
    </List>
  )
}

function RoleItem( props ) {
  const { item, onEvent, ...rest } = props
  const { id, displayName, name, permissions = [] } = item
  let type = 'PROJECT'
  if ( item.projectId === 'imagine' ) {
    type = 'IMAGINE'
  } else if ( item.scope === 'custom' ) {
    type = 'CUSTOM'
  }

  return (
    <List.Item item={item} {...rest} >
      <Flex variant="rowM">
        <Button variant="secondaryTinyIconic" onClick={onEvent} eventData={item}><i className="fa fa-plus"/></Button>
        <Text variant="listItemSubtitle">{displayName || name} ( {permissions.length} )</Text>
        <Text variant="info" style={{ textAlign : 'right', flex : 1 }}>{type}</Text>
      </Flex>
    </List.Item>
  )
}
